import { render, staticRenderFns } from "./modelManage.vue?vue&type=template&id=1ce83a31&"
import script from "./modelManage.vue?vue&type=script&lang=js&"
export * from "./modelManage.vue?vue&type=script&lang=js&"
import style0 from "./modelManage.vue?vue&type=style&index=0&id=1ce83a31&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports